import "./App.css";
import Layout from "./components/layouts/Layout";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import AboutUs from "./pages/AboutUs/AboutUs";
import Career from "./pages/Career/Career";
import ContactUs from "./pages/ContactUs/ContactUs";
import PrivacyPolicy from "./pages/Privacypolicy/PrivacyPolicy";
import ReturnPolicy from "./pages/Return Policy/ReturnPolicy";
import ShippingPolicy from "./pages/ShippingPolicy/ShippingPolicy";
import TermsaAndConditions from "./pages/TermsaAndConditions/TermsaAndConditions";
import Delivery from "./pages/Delivery/Delivery";
import Disclaimer from "./pages/Disclaimer/Disclaimer";
import JobDescription from "./pages/JobDescription/JobDescription";
// import Faqs from "./pages/Faqs/Faqs";

function App() {
  return (
    <>
      <div>
        <Router>
          <Routes>
            <Route exact path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route exact path="/about-us" element={<AboutUs />} />
              <Route exact path="/Careers" element={<Career />} />
              <Route exact path="/contact-us" element={<ContactUs />} />
              <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route exact path="/return-policy" element={<ReturnPolicy />} />
              <Route
                exact
                path="/shipping-policy"
                element={<ShippingPolicy />}
              />
              <Route
                path="/terms-and-conditions"
                element={<TermsaAndConditions />}
              />
              <Route path="/delivery" element={<Delivery />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/job-description" element={<JobDescription />} />
              {/* <Route path="/faqs" element={<Faqs />} /> */}
            </Route>
          </Routes>
        </Router>
      </div>
    </>
  );
}

export default App;
